import { components } from 'types/rest-schema';

export type FieldDefsAndRDLsDto = components['schemas']['FieldDefsAndRDLsDto'] & {
    fields?: FieldDefinitionDto[] | null;
    rdLs?: RowDataSourceDto[] | null;
};

// NOTE - keep in sync with RowDataSourceTable.cs in CM2 Service BE
export enum RowDataSourceTableDto {
    NONE = 'NONE',
    SITE = 'SITE',
    SITE_ISSUE = 'SITE_ISSUE',
    SITE_PROTOCOL_DEVIATION = 'SITE_PROTOCOL_DEVIATION',
    SITE_VISIT = 'SITE_VISIT',
    STUDY = 'STUDY',
    SUBJECT = 'SUBJECT',
    SUBJECT_ADVERSE_EVENT = 'SUBJECT_ADVERSE_EVENT',
    SUBJECT_ASSESSMENT = 'SUBJECT_ASSESSMENT',
    SUBJECT_CRF = 'SUBJECT_CRF',
    SUBJECT_INFORMED_CONSENT = 'SUBJECT_INFORMED_CONSENT',
    SUBJECT_ISSUE = 'SUBJECT_ISSUE',
    SUBJECT_LAB = 'SUBJECT_LAB',
    SUBJECT_PROTOCOL_DEVIATION = 'SUBJECT_PROTOCOL_DEVIATION',
    SUBJECT_QUERY = 'SUBJECT_QUERY',
    SUBJECT_VISIT = 'SUBJECT_VISIT',
}

// NOTE - keep in sync with RowDataSourceTable.cs in CM2 Service BE
export enum FieldDefinitionFieldTypeDto {
    BOOL = 'BOOL',
    DATE = 'DATE',
    FLOAT = 'FLOAT',
    INT = 'INT',
    PARTIAL_DATE = 'PARTIAL_DATE',
    TEXT = 'TEXT',
    UNDEFINED = 'UNDEFINED',
    LONG = 'LONG',
}

// NOTE - keep in sync with FieldTag.cs in BE
export enum FieldTagDto {
    SUBJECT_POPULATION = 'SUBJECT_POPULATION',
}

// NOTE - keep in sync with RowDataSourceTag.cs in BE
export enum RowDataSourceTagDto {
    DATA_TABLE = 'DATA_TABLE',
    DATA_TABLE_DATA_LISTING = 'DATA_TABLE_DATA_LISTING',
    DATA_TABLE_SITE_SUMMARY = 'DATA_TABLE_SITE_SUMMARY',
    DATA_TABLE_SUBJECT_SUMMARY = 'DATA_TABLE_SUBJECT_SUMMARY',
    PANEL = 'PANEL',
    SITE_LISTING = 'SITE_LISTING',
}

export type FieldDefinitionDto = components['schemas']['FieldDefinitionDto'] & {
    name: string;
    description?: string | null;
    key: string;
    resolver?: string | null;
    dataType: RowDataSourceTableDto;
    fieldType: FieldDefinitionFieldTypeDto;
    tags?: FieldTagDto[] | null;
    isCalculated: boolean;
    isHidden: boolean;
    rowDataSource?: string | null;
};

export type RowDataSourceDto = components['schemas']['RowDataSourceDto'] & {
    id: string;
    name: string;
    tags?: RowDataSourceTagDto[] | null;
    table: RowDataSourceTableDto;
    default: boolean;
};
